import SharedCalendarViewState from '../store/schema/SharedCalendarViewState';
import getStore from '../store/store';

/**
 * Gets shareable calendars of shared calendar options store
 */
export default function(): SharedCalendarViewState[] {
    return getStore().calendars;
}
